import React from "react";

export class Tags extends React.Component {
  render() {
    const tags = this.props.tags;
    return (
      <div className="specification">
        {tags &&
          tags.map((tag, index) => {
            return (
              <div className="item" key={index}>
                {tag === '断熱' ? '断熱材' : tag}
              </div>
            )
          })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./pages/area/Tags.jsx